// src/api/programs/programs.ts
import { useApiClient } from "../apiClients";
import { PROGRAMS_ENDPOINTS } from "./endpoints";
import type { Program } from "../../models/domain";

export type CreateProgramPayload = Omit<
    Program,
    "id" | "created_at" | "updated_at"
>;

export type UpdateProgramPayload = Partial<CreateProgramPayload>;

export const useProgramsApi = () => {
    const apiClient = useApiClient("embed");

    const listPrograms = () =>
        apiClient.get<Program[]>(PROGRAMS_ENDPOINTS.BASE);

    const getProgram = (programId: string) =>
        apiClient.get<Program>(PROGRAMS_ENDPOINTS.DETAIL(programId));

    const createProgram = (payload: CreateProgramPayload) =>
        apiClient.post<Program>(PROGRAMS_ENDPOINTS.BASE, payload);

    const updateProgram = (
        programId: string,
        payload: UpdateProgramPayload
    ) => apiClient.put<Program>(PROGRAMS_ENDPOINTS.DETAIL(programId), payload);

    const deleteProgram = (programId: string) =>
        apiClient.delete<void>(PROGRAMS_ENDPOINTS.DETAIL(programId));

    return {
        listPrograms,
        getProgram,
        createProgram,
        updateProgram,
        deleteProgram,
    };
};
